import { Outlet } from "react-router-dom"

export default function MyPage() {
    return (
        <div className="mobile:pb-[56px]">
            <Outlet />
        </div>
    )
}